export const Bio = {
  name: "Fabio Mughilan",
  roles: [
    "Full Stack Developer",
    "LLM Developer",
    "Web3 Developer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/fabiomughilan",
  resume:
    "https://drive.google.com/file/d/1uIW1yDDUDWapWQsupvuxsuje0nBuUHcW/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/fabiomughilan/",
  twitter: "https://x.com/fabiomughilan",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Web3",
    skills: [
      {
        name: "Solidity",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/solidity/solidity-original.svg",
      },
      {
        name: "Hyperledger",
        image:
          "https://www.vectorlogo.zone/logos/hyperledger/hyperledger-icon.svg",
      },
      {
        name: "Ethereum",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Web3.js",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
      {
        name: "Adobe XD",
        image:
          "https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667",
      },
      {
        name: "Figma",
        image:
          "https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "",
    role: "Blockchain & Full-Stack Developer",
    company: "Freelance",
    date: "Jan 2024 - Present",
    desc: "I have delivered end-to-end decentralized applications, including DeFi platforms, NFT marketplaces, and token smart contracts, integrating multi-chain support across Ethereum, Polygon, BSC, and Cosmos-based networks, developing and auditing Solidity contracts with features like slippage control, fee handling, and routing, while building scalable frontends using React/Next.js with ethers.js and wagmi for seamless wallet integrations.",
    skills: [
  "Solidity",
  "Ethereum",
  "Polygon",
  "BSC",
  "MERN Stack",
  "React/Next.js",
  "ethers.js",
  "wagmi",
  "IPFS",
  "DeFi & NFT Development",
  "Hardhat",
  "Foundry"
],

  },
  {
    id: 0,
    img: "data:image/jpeg;base64,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",
    role: "Cybersecurity Intern",
    company: "L&T Technology Services",
    date: "Jan 2025- Feb 2025",
    desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
    skills: [
      "XDR",
      "SIEM",
      "Azure",
      "Python",
      "Incident Handling"
    ],
  },
  {
    id: 0,
    img: "data:image/png;base64,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",
    role: "Full Stack Intern",
    company: "Nexus Info",
    date: "June 2023 - Present",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],

  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSEFmIn8XBBO6HvPJsFyE-7yBMbEATGtVzAA&s",
    role: "AI&ML Intern",
    company: "NIELIT Calicut",
    date: "June 2023 - Present",
    desc: "Working on the frontend of the web application using ReactJS, Redux, and Material UI.",
    skills: [
      "Python",
      "Machine Learning",
      "Scikit-learn",
      "TensorFlow",
      "Keras",
      "NLP",
    ],
  }
];

export const education = [
  {
    id: 0,
    img: "https://www.veltech.edu.in/wp-content/uploads/2022/05/logo-white-249x249.png",
    school: "Vel Tech Rangarajan Dr.Sagunthala R&D Institute of Science and Technology, Chennai",
    date: "Sept 2022 - May 2026",
    grade: "8.4 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Vel Tech Rangarajan Dr.Sagunthala R&D Institute of Science and Technology, Chennai. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/en/f/f0/The_Oxford_School%2C_Trivandrum_logo.png",
    school: "The Oxford School, Trivandrum",
    date: "Apr 2021 - Apr 2022",
    grade: "77%",
    desc: "I completed my class 12 high school education at The Oxford School, Trivandrum, where I studied Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/en/f/f0/The_Oxford_School%2C_Trivandrum_logo.png",
    school: "The Oxford School, Trivandrum",
    date: "Jun 2019 - Apr 2020",
    grade: "84%",
    desc: "I completed my class 10 education at The Oxford School, Trivandrum, where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 9,
    title: "0xSwap",
    date: "July - August 2025",
    description:
      "0xSwap is a gamified DeFi platform where cross-chain swaps become magical, tradable NFTs.",
    image:
      "https://github.com/user-attachments/assets/70ce0888-1d94-4dc1-9580-e709f367b2ef",
    tags: [
      "Solidity",
      "Hardhat",
      "Sepolia",
      "1inch Fusion+ API",
      "LayerZero",
      "React Js",
      "Ethers.js",
      "WalletConnect",
      "Node Js",
      "GitHub",
    ],
    category: ["web app","blockchain"],
    github: "https://github.com/fabiomughilan/OxSwap",
    webapp: "https://github.com/fabiomughilan/OxSwap",
  },
  {
    id: 0,
    title: "Luffy Dex",
    date: "Jun 2025",
    description:
      "Developed a decentralized exchange (DEX) platform that allows users to trade cryptocurrencies securely and efficiently. Implemented smart contracts using Solidity and integrated with the Ethereum blockchain. Designed a user-friendly interface with React JS and ensured seamless communication between the front end and smart contracts using Ethers.js.",
    image:
      "https://github.com/user-attachments/assets/9d2aca9b-98a6-4e8c-964f-132abbfde538",
    tags: ["React Js", "1inch Fusion+ API", "Node Js", "Ethers.js", "WalletConnect","JavaScript"],
    category: ["web app", "blockchain"],
    github: "https://github.com/fabiomughilan/Luffy-DEX",
    webapp: "https://luffy-dex.vercel.app/",
  },
  {
    id: 1,
    title: "Sonic AI",
    date: "Feb 2025",
    description:
      "SonicAi is a platform featuring multiple AI agents to help users transact tokens on Sonic Ecosystem The main aim of the platform is to provide users with profitable opportunities through various DeFi operations such as swapping tokens, get balance, deploy NFTs, approving ERC20 tokens, and more.The platform leverages AI agents built using LangChain and LangGraph to analyze market data, execute trades, and automate tasks without unnecessary user intervention. Agents collaborate autonomously to complete tasks efficiently, ensuring seamless execution while keeping technical complexities hidden from the user.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "Python",
      "LLM's",
      "Zerepy",
      "Sonic ",
      "DeFi",
      "AI agents",
    ],
    category: ["AI", "blockchain"],
    github: "https://github.com/fabiomughilan/SonicAI",
  },
  {
    id: 3,
    title: "Health Mind Chat Bot",
    date: "Dec 2021 - Apr 2022",
    description:
      "AI chatbot that provides personalized support in mental health and dietary advice. It uses natural language processing to understand user queries and provide relevant responses. The chatbot is designed to be user-friendly and accessible, making it easy for users to get the help they need.Powered by a multi-agent architecture using CrewAI, it leverages large language models (LLMs) via Together.ai,along with semantic search using ChromaDB.",
    image:
      "https://github.com/user-attachments/assets/bf43935d-4326-4a9a-bbf5-ed1784235a5a",
    tags: ["Python", "Flask", "Mixtral", "FastAPI", "ChromaDB", "CrewAI", "TogetherAI"],
    category: ["web app","AI"],
    github: "https://github.com/fabiomughilan/Chatbot",
    webapp: "https://fabiomughilan-chatbot-chat-agentschat-ui-cdgxwc.streamlit.app/",
  },
  {
    id: 2,
    title: "Workverse",
    date: "Nov 2024",
    description:
      "Developed a 2D virtual office using Phaser3 and React.js with Web3 features like Privy and Push Protocol.Integrated Redux and Tiled for gamified collaboration and map editing.Won Ethglobal Bangkok with the bounty of $2000",
    image:
      "https://github.com/user-attachments/assets/89af8ce2-b743-4945-92f4-fe63e7df9a19",
    tags: ["TypeScript","React", "Redux", "Node.js", "Push Protocol","Github"],
    category: ["web app","blockchain"],
    github: "https://github.com/fabiomughilan/workverse",
    webapp: "https://github.com/fabiomughilan/workverse",
  },
  
  {
    id: 10,
    title: "Fireworks Ecommerce Website",
    date: "Jun 2023 - Jul 2023",
    description:
      "Built a Fireworks Ecommerce Website including customer portal and seller portal using React, MongoDB, and Firebase.",
    image:
      "https://github.com/user-attachments/assets/789c7aa6-59c1-4d02-a40b-f504e0a6f19e",
    tags: ["React", "JavaScript", "Axios","MongoDB"],
    category: "web app",
    github: "https://github.com/fabiomughilan/Fireworks-Ecommerce",
    webapp: "https://fireworksclient.netlify.app/",
  },
  {
    id: 4,
    title: "Phishing URL Detection using Ensemble Method",
    date: "Jul 2023",
    description:
      "This project focuses on detecting phishing URLs using machine learning, specifically an ensemble method that combines decision trees and takes a majority vote for classification. By analyzing features like domain name, URL length, keywords, and HTTP usage, the model can identify both known and unknown phishing attempts. Trained on a processed phishing URL dataset, the system achieves 87% accuracy, offering a reliable approach to phishing prevention and reducing the risk of attacks.",
    image:
      "https://github.com/user-attachments/assets/79da653e-de9f-40cc-8913-719c4c66d8bf",
    tags: ["Python", "TensorFlow","Machine Learning","GoogleColab"],
    category: "AI",
    github: "https://github.com/fabiomughilan/Phishing-URL-Detection-using-Ensemble-method"
  },
  {
    id: 5,
    title: "GST Prediction using LightGBM",
    date: "Oct 2024",
    description:
      "This project applies LightGBM to GST data classification, taking advantage of its speed, efficiency, and ability to handle missing values and imbalanced datasets without extensive preprocessing. After removing irrelevant metadata, the model was configured with GBDT boosting, 100 estimators, a 0.1 learning rate, automatic depth selection, and 80% subsampling for rows and features to enhance generalization. Trained using leaf-wise growth, LightGBM delivered strong performance, achieving 97.83% accuracy, 84.53% precision, 94.21% recall, 89.11% F1 score, 96.21% balanced accuracy, 0.0491 log loss, and an impressive 0.9949 AUC-ROC, demonstrating high accuracy and robustness in handling large datasets efficiently.",
    image:
      "https://github.com/user-attachments/assets/8c206814-d362-4c34-919e-b294ab7294f7",
    tags: ["Python", "Machine Learning", "LightGBM"],
    category: "AI",
    github: "https://github.com/fabiomughilan/GST"
  }
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
